import { OrgId } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";
import { validateToken } from "../../internal-utils/server-auth";

/**
 * Returns the PUBLIC Collect.js tokenization key for an org's NMI merchant account, used by the web
 * payment page to initialize Collect.js. Deliberately returns ONLY that one field — never the
 * encrypted merchant API key or anything else on OrgSecret. The key is public by design (it ships to
 * the browser) and can only mint one-time payment tokens, so exposing it to an authenticated caller
 * carries no risk.
 */
export async function orgSecret__server__getCollectJsTokenizationKey(p: {
  orgId: OrgId;
}): Promise<{ collectJsTokenizationKey: string | null }> {
  // SERVER_ONLY_TOGGLE

  const { ollieFirestoreV2: h } = getUniversalHelpers();

  const orgSecret = await h.OrgSecret.getDoc(p.orgId);

  return { collectJsTokenizationKey: orgSecret?.nmiConfig?.collectJsTokenizationKey ?? null };

  // SERVER_ONLY_TOGGLE
}

orgSecret__server__getCollectJsTokenizationKey.auth = async (req: any) => {
  await validateToken(req);
};
